import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { animate, cancelAnimation } from "../Utils/Utils";
import { Canvas } from "./Canvas";
import { EventListeners } from "./Utils/EventListeners";
import { FrameManager } from "./Utils/FrameManager";
import { Options } from "../Options/Classes/Options";
import { Particles } from "./Particles";
import { Retina } from "./Retina";
import { getRangeValue } from "../Utils/NumberUtils";
import { loadOptions } from "../Utils/OptionsUtils";

function guardCheck(container) {
  return container && !container.destroyed;
}

function loadContainerOptions(engine, container) {
  var options = new Options(engine, container);

  for (var _len = arguments.length, sourceOptionsArr = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    sourceOptionsArr[_key - 2] = arguments[_key];
  }

  loadOptions.apply(void 0, [options].concat(sourceOptionsArr));
  return options;
}

var defaultPathGeneratorKey = "default",
    defaultPathGenerator = {
  generate: function generate(p) {
    var v = p.velocity.copy();
    v.angle += v.length * Math.PI / 180;
    return v;
  },
  init: function init() {},
  update: function update() {},
  reset: function reset() {}
};
export var Container = /*#__PURE__*/function () {
  function Container(engine, id, sourceOptions) {
    var _this = this;

    _classCallCheck(this, Container);

    this.id = id;
    this._engine = engine;
    this.fpsLimit = 120;
    this.smooth = false;
    this._delay = 0;
    this.duration = 0;
    this.lifeTime = 0;
    this._firstStart = true;
    this.started = false;
    this.destroyed = false;
    this._paused = true;
    this.lastFrameTime = 0;
    this.zLayers = 100;
    this.pageHidden = false;
    this._sourceOptions = sourceOptions;
    this._initialSourceOptions = sourceOptions;
    this.retina = new Retina(this);
    this.canvas = new Canvas(this);
    this.particles = new Particles(this._engine, this);
    this.frameManager = new FrameManager(this);
    this.pathGenerators = new Map();
    this.interactivity = {
      mouse: {
        clicking: false,
        inside: false
      }
    };
    this.plugins = new Map();
    this.drawers = new Map();
    this._options = loadContainerOptions(this._engine, this);
    this.actualOptions = loadContainerOptions(this._engine, this);
    this._eventListeners = new EventListeners(this);

    if (typeof IntersectionObserver !== "undefined" && IntersectionObserver) {
      this._intersectionObserver = new IntersectionObserver(function (entries) {
        return _this._intersectionManager(entries);
      });
    }

    this._engine.dispatchEvent("containerBuilt", {
      container: this
    });
  }

  _createClass(Container, [{
    key: "options",
    get: function get() {
      return this._options;
    }
  }, {
    key: "sourceOptions",
    get: function get() {
      return this._sourceOptions;
    }
  }, {
    key: "addClickHandler",
    value: function addClickHandler(callback) {
      var _this2 = this;

      if (!guardCheck(this)) {
        return;
      }

      var el = this.interactivity.element;

      if (!el) {
        return;
      }

      var clickOrTouchHandler = function clickOrTouchHandler(e, pos, radius) {
        if (!guardCheck(_this2)) {
          return;
        }

        var pxRatio = _this2.retina.pixelRatio,
            posRetina = {
          x: pos.x * pxRatio,
          y: pos.y * pxRatio
        },
            particles = _this2.particles.quadTree.queryCircle(posRetina, radius * pxRatio);

        callback(e, particles);
      };

      var clickHandler = function clickHandler(e) {
        if (!guardCheck(_this2)) {
          return;
        }

        var mouseEvent = e,
            pos = {
          x: mouseEvent.offsetX || mouseEvent.clientX,
          y: mouseEvent.offsetY || mouseEvent.clientY
        };
        clickOrTouchHandler(e, pos, 1);
      };

      var touchStartHandler = function touchStartHandler() {
        if (!guardCheck(_this2)) {
          return;
        }

        touched = true;
        touchMoved = false;
      };

      var touchMoveHandler = function touchMoveHandler() {
        if (!guardCheck(_this2)) {
          return;
        }

        touchMoved = true;
      };

      var touchEndHandler = function touchEndHandler(e) {
        if (!guardCheck(_this2)) {
          return;
        }

        if (touched && !touchMoved) {
          var touchEvent = e;
          var lastTouch = touchEvent.touches[touchEvent.touches.length - 1];

          if (!lastTouch) {
            lastTouch = touchEvent.changedTouches[touchEvent.changedTouches.length - 1];

            if (!lastTouch) {
              return;
            }
          }

          var element = _this2.canvas.element,
              canvasRect = element ? element.getBoundingClientRect() : undefined,
              pos = {
            x: lastTouch.clientX - (canvasRect ? canvasRect.left : 0),
            y: lastTouch.clientY - (canvasRect ? canvasRect.top : 0)
          };
          clickOrTouchHandler(e, pos, Math.max(lastTouch.radiusX, lastTouch.radiusY));
        }

        touched = false;
        touchMoved = false;
      };

      var touchCancelHandler = function touchCancelHandler() {
        if (!guardCheck(_this2)) {
          return;
        }

        touched = false;
        touchMoved = false;
      };

      var touched = false,
          touchMoved = false;
      el.addEventListener("click", clickHandler);
      el.addEventListener("touchstart", touchStartHandler);
      el.addEventListener("touchmove", touchMoveHandler);
      el.addEventListener("touchend", touchEndHandler);
      el.addEventListener("touchcancel", touchCancelHandler);
    }
  }, {
    key: "addPath",
    value: function addPath(key, generator) {
      var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!guardCheck(this) || !override && this.pathGenerators.has(key)) {
        return false;
      }

      this.pathGenerators.set(key, generator !== null && generator !== void 0 ? generator : defaultPathGenerator);
      return true;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this3 = this;

      if (!guardCheck(this)) {
        return;
      }

      this.stop();
      this.particles.destroy();
      this.canvas.destroy();

      var _iterator = _createForOfIteratorHelper(this.drawers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ref3 = _step.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var drawer = _ref2[1];

          if (drawer.destroy) {
            drawer.destroy(this);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(this.drawers.keys()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          this.drawers.delete(key);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this._engine.plugins.destroy(this);

      this.destroyed = true;

      var mainArr = this._engine.dom(),
          idx = mainArr.findIndex(function (t) {
        return t === _this3;
      });

      if (idx >= 0) {
        mainArr.splice(idx, 1);
      }

      this._engine.dispatchEvent("containerDestroyed", {
        container: this
      });
    }
  }, {
    key: "draw",
    value: function draw(force) {
      var _this4 = this;

      if (!guardCheck(this)) {
        return;
      }

      var refreshTime = force;
      this._drawAnimationFrame = animate()( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(timestamp) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (refreshTime) {
                    _this4.lastFrameTime = undefined;
                    refreshTime = false;
                  }

                  _context.next = 3;
                  return _this4.frameManager.nextFrame(timestamp);

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "exportConfiguration",
    value: function exportConfiguration() {
      return JSON.stringify(this.actualOptions, function (key, value) {
        if (key === "_engine" || key === "_container") {
          return;
        }

        return value;
      }, 2);
    }
  }, {
    key: "exportImage",
    value: function exportImage(callback, type, quality) {
      var element = this.canvas.element;

      if (element) {
        element.toBlob(callback, type !== null && type !== void 0 ? type : "image/png", quality);
      }
    }
  }, {
    key: "exportImg",
    value: function exportImg(callback) {
      this.exportImage(callback);
    }
  }, {
    key: "getAnimationStatus",
    value: function getAnimationStatus() {
      return !this._paused && !this.pageHidden && guardCheck(this);
    }
  }, {
    key: "handleClickMode",
    value: function handleClickMode(mode) {
      if (!guardCheck(this)) {
        return;
      }

      this.particles.handleClickMode(mode);

      var _iterator3 = _createForOfIteratorHelper(this.plugins),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _ref7 = _step3.value;

          var _ref6 = _slicedToArray(_ref7, 2);

          var plugin = _ref6[1];

          if (plugin.handleClickMode) {
            plugin.handleClickMode(mode);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var shapes, _iterator4, _step4, type, drawer, availablePlugins, _iterator5, _step5, _ref16, _ref9, id, plugin, _iterator6, _step6, _ref17, _ref11, _drawer, _iterator7, _step7, _ref18, _ref13, _plugin, _iterator8, _step8, _ref19, _ref15, _plugin2;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (guardCheck(this)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                shapes = this._engine.plugins.getSupportedShapes();
                _iterator4 = _createForOfIteratorHelper(shapes);

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    type = _step4.value;
                    drawer = this._engine.plugins.getShapeDrawer(type);

                    if (drawer) {
                      this.drawers.set(type, drawer);
                    }
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }

                this._options = loadContainerOptions(this._engine, this, this._initialSourceOptions, this.sourceOptions);
                this.actualOptions = loadContainerOptions(this._engine, this, this._options);
                availablePlugins = this._engine.plugins.getAvailablePlugins(this);
                _iterator5 = _createForOfIteratorHelper(availablePlugins);

                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    _ref16 = _step5.value;
                    _ref9 = _slicedToArray(_ref16, 2);
                    id = _ref9[0];
                    plugin = _ref9[1];
                    this.plugins.set(id, plugin);
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }

                this.retina.init();
                _context2.next = 13;
                return this.canvas.init();

              case 13:
                this.updateActualOptions();
                this.canvas.initBackground();
                this.canvas.resize();
                this.zLayers = this.actualOptions.zLayers;
                this.duration = getRangeValue(this.actualOptions.duration) * 1000;
                this._delay = getRangeValue(this.actualOptions.delay) * 1000;
                this.lifeTime = 0;
                this.fpsLimit = this.actualOptions.fpsLimit > 0 ? this.actualOptions.fpsLimit : 120;
                this.smooth = this.actualOptions.smooth;
                _iterator6 = _createForOfIteratorHelper(this.drawers);
                _context2.prev = 23;

                _iterator6.s();

              case 25:
                if ((_step6 = _iterator6.n()).done) {
                  _context2.next = 34;
                  break;
                }

                _ref17 = _step6.value;
                _ref11 = _slicedToArray(_ref17, 2);
                _drawer = _ref11[1];

                if (!_drawer.init) {
                  _context2.next = 32;
                  break;
                }

                _context2.next = 32;
                return _drawer.init(this);

              case 32:
                _context2.next = 25;
                break;

              case 34:
                _context2.next = 39;
                break;

              case 36:
                _context2.prev = 36;
                _context2.t0 = _context2["catch"](23);

                _iterator6.e(_context2.t0);

              case 39:
                _context2.prev = 39;

                _iterator6.f();

                return _context2.finish(39);

              case 42:
                _iterator7 = _createForOfIteratorHelper(this.plugins);
                _context2.prev = 43;

                _iterator7.s();

              case 45:
                if ((_step7 = _iterator7.n()).done) {
                  _context2.next = 54;
                  break;
                }

                _ref18 = _step7.value;
                _ref13 = _slicedToArray(_ref18, 2);
                _plugin = _ref13[1];

                if (!_plugin.init) {
                  _context2.next = 52;
                  break;
                }

                _context2.next = 52;
                return _plugin.init();

              case 52:
                _context2.next = 45;
                break;

              case 54:
                _context2.next = 59;
                break;

              case 56:
                _context2.prev = 56;
                _context2.t1 = _context2["catch"](43);

                _iterator7.e(_context2.t1);

              case 59:
                _context2.prev = 59;

                _iterator7.f();

                return _context2.finish(59);

              case 62:
                this._engine.dispatchEvent("containerInit", {
                  container: this
                });

                this.particles.init();
                this.particles.setDensity();
                _iterator8 = _createForOfIteratorHelper(this.plugins);

                try {
                  for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                    _ref19 = _step8.value;
                    _ref15 = _slicedToArray(_ref19, 2);
                    _plugin2 = _ref15[1];

                    if (_plugin2.particlesSetup) {
                      _plugin2.particlesSetup();
                    }
                  }
                } catch (err) {
                  _iterator8.e(err);
                } finally {
                  _iterator8.f();
                }

                this._engine.dispatchEvent("particlesSetup", {
                  container: this
                });

              case 68:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[23, 36, 39, 42], [43, 56, 59, 62]]);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "loadTheme",
    value: function () {
      var _loadTheme = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(name) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (guardCheck(this)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                this._currentTheme = name;
                _context3.next = 5;
                return this.refresh();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadTheme(_x2) {
        return _loadTheme.apply(this, arguments);
      }

      return loadTheme;
    }()
  }, {
    key: "pause",
    value: function pause() {
      if (!guardCheck(this)) {
        return;
      }

      if (this._drawAnimationFrame !== undefined) {
        cancelAnimation()(this._drawAnimationFrame);
        delete this._drawAnimationFrame;
      }

      if (this._paused) {
        return;
      }

      var _iterator9 = _createForOfIteratorHelper(this.plugins),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _ref22 = _step9.value;

          var _ref21 = _slicedToArray(_ref22, 2);

          var plugin = _ref21[1];

          if (plugin.pause) {
            plugin.pause();
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      if (!this.pageHidden) {
        this._paused = true;
      }

      this._engine.dispatchEvent("containerPaused", {
        container: this
      });
    }
  }, {
    key: "play",
    value: function play(force) {
      if (!guardCheck(this)) {
        return;
      }

      var needsUpdate = this._paused || force;

      if (this._firstStart && !this.actualOptions.autoPlay) {
        this._firstStart = false;
        return;
      }

      if (this._paused) {
        this._paused = false;
      }

      if (needsUpdate) {
        var _iterator10 = _createForOfIteratorHelper(this.plugins),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var _ref25 = _step10.value;

            var _ref24 = _slicedToArray(_ref25, 2);

            var plugin = _ref24[1];

            if (plugin.play) {
              plugin.play();
            }
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }

      this._engine.dispatchEvent("containerPlay", {
        container: this
      });

      this.draw(needsUpdate || false);
    }
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (guardCheck(this)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                this.stop();
                return _context4.abrupt("return", this.start());

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (guardCheck(this)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                this._options = loadContainerOptions(this._engine, this);
                return _context5.abrupt("return", this.refresh());

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "setNoise",
    value: function setNoise(noiseOrGenerator, init, update) {
      if (!guardCheck(this)) {
        return;
      }

      this.setPath(noiseOrGenerator, init, update);
    }
  }, {
    key: "setPath",
    value: function setPath(pathOrGenerator, init, update) {
      if (!pathOrGenerator || !guardCheck(this)) {
        return;
      }

      var pathGenerator = Object.assign({}, defaultPathGenerator);

      if (typeof pathOrGenerator === "function") {
        pathGenerator.generate = pathOrGenerator;

        if (init) {
          pathGenerator.init = init;
        }

        if (update) {
          pathGenerator.update = update;
        }
      } else {
        var oldGenerator = pathGenerator;
        pathGenerator.generate = pathOrGenerator.generate || oldGenerator.generate;
        pathGenerator.init = pathOrGenerator.init || oldGenerator.init;
        pathGenerator.update = pathOrGenerator.update || oldGenerator.update;
      }

      this.addPath(defaultPathGeneratorKey, pathGenerator, true);
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _this5 = this;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(!guardCheck(this) || this.started)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                _context7.next = 4;
                return this.init();

              case 4:
                this.started = true;
                _context7.next = 7;
                return new Promise(function (resolve) {
                  _this5._delayTimeout = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                    var _iterator11, _step11, _ref29, _ref28, plugin;

                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _this5._eventListeners.addListeners();

                            if (_this5.interactivity.element instanceof HTMLElement && _this5._intersectionObserver) {
                              _this5._intersectionObserver.observe(_this5.interactivity.element);
                            }

                            _iterator11 = _createForOfIteratorHelper(_this5.plugins);
                            _context6.prev = 3;

                            _iterator11.s();

                          case 5:
                            if ((_step11 = _iterator11.n()).done) {
                              _context6.next = 14;
                              break;
                            }

                            _ref29 = _step11.value;
                            _ref28 = _slicedToArray(_ref29, 2);
                            plugin = _ref28[1];

                            if (!plugin.start) {
                              _context6.next = 12;
                              break;
                            }

                            _context6.next = 12;
                            return plugin.start();

                          case 12:
                            _context6.next = 5;
                            break;

                          case 14:
                            _context6.next = 19;
                            break;

                          case 16:
                            _context6.prev = 16;
                            _context6.t0 = _context6["catch"](3);

                            _iterator11.e(_context6.t0);

                          case 19:
                            _context6.prev = 19;

                            _iterator11.f();

                            return _context6.finish(19);

                          case 22:
                            _this5._engine.dispatchEvent("containerStarted", {
                              container: _this5
                            });

                            _this5.play();

                            resolve();

                          case 25:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6, null, [[3, 16, 19, 22]]);
                  })), _this5._delay);
                });

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function stop() {
      if (!guardCheck(this) || !this.started) {
        return;
      }

      if (this._delayTimeout) {
        clearTimeout(this._delayTimeout);
        delete this._delayTimeout;
      }

      this._firstStart = true;
      this.started = false;

      this._eventListeners.removeListeners();

      this.pause();
      this.particles.clear();
      this.canvas.clear();

      if (this.interactivity.element instanceof HTMLElement && this._intersectionObserver) {
        this._intersectionObserver.unobserve(this.interactivity.element);
      }

      var _iterator12 = _createForOfIteratorHelper(this.plugins),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _ref32 = _step12.value;

          var _ref31 = _slicedToArray(_ref32, 2);

          var plugin = _ref31[1];

          if (plugin.stop) {
            plugin.stop();
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }

      var _iterator13 = _createForOfIteratorHelper(this.plugins.keys()),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var key = _step13.value;
          this.plugins.delete(key);
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }

      this._sourceOptions = this._options;

      this._engine.dispatchEvent("containerStopped", {
        container: this
      });
    }
  }, {
    key: "updateActualOptions",
    value: function updateActualOptions() {
      this.actualOptions.responsive = [];
      var newMaxWidth = this.actualOptions.setResponsive(this.canvas.size.width, this.retina.pixelRatio, this._options);
      this.actualOptions.setTheme(this._currentTheme);

      if (this.responsiveMaxWidth === newMaxWidth) {
        return false;
      }

      this.responsiveMaxWidth = newMaxWidth;
      return true;
    }
  }, {
    key: "_intersectionManager",
    value: function _intersectionManager(entries) {
      if (!guardCheck(this) || !this.actualOptions.pauseOnOutsideViewport) {
        return;
      }

      var _iterator14 = _createForOfIteratorHelper(entries),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var entry = _step14.value;

          if (entry.target !== this.interactivity.element) {
            continue;
          }

          (entry.isIntersecting ? this.play : this.pause)();
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
    }
  }]);

  return Container;
}();